export default __webpack_public_path__ + "static/media/ic_tracker_on.c54e07bf.svg";